import React from 'react';
import { useNavigate } from 'react-router-dom';
import { employeesOverviewPath, isOverviewTab, type EmployeeOverviewTab } from '../../utils/employeeRoutes';

const OVERVIEW_TABS: Array<{
  id: EmployeeOverviewTab;
  label: string;
}> = [
  { id: 'uebersicht', label: 'Übersicht' },
  { id: 'antraege', label: 'Anträge' },
  { id: 'be-abzuege', label: 'Be- und Abzüge' },
  { id: 'lohnbuchhaltung', label: 'Lohnbuchhaltung' },
];

type EmployeeOverviewShellProps = {
  instanceId: string;
  activeTab: EmployeeOverviewTab;
  periodQuery?: string;
  children: React.ReactNode;
};

export function EmployeeOverviewShell({
  instanceId,
  activeTab,
  periodQuery,
  children,
}: EmployeeOverviewShellProps) {
  const navigate = useNavigate();

  const navigateTab = (tab: EmployeeOverviewTab) => {
    const path = employeesOverviewPath(instanceId, tab);
    navigate(periodQuery ? `${path}?${periodQuery}` : path);
  };

  return (
    <div className="flex-1 min-w-0 overflow-hidden flex flex-col bg-app-surface">
      <div className="shrink-0 border-b border-app-border bg-app-surface px-6 pt-2">
        <div className="flex items-end gap-0 -mb-px">
          {OVERVIEW_TABS.map((t) => {
            const active = activeTab === t.id;
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => navigateTab(t.id)}
                className={`inline-flex items-center px-[18px] py-[10px] text-sm font-medium border-b-2 transition-colors ${
                  active
                    ? 'text-pipedrive-blue border-pipedrive-blue'
                    : 'text-app-text-subtle border-transparent hover:text-app-text-muted'
                }`}
              >
                {t.label}
              </button>
            );
          })}
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden flex flex-col bg-app-bg">{children}</div>
    </div>
  );
}

export function overviewTabFromParam(value: string | undefined): EmployeeOverviewTab {
  return isOverviewTab(value) ? value : 'uebersicht';
}
